import { render, staticRenderFns } from "./WeeklyThermalCpuBurnInFailRateSummary.vue?vue&type=template&id=70478dbe"
import script from "./WeeklyThermalCpuBurnInFailRateSummary.vue?vue&type=script&lang=js"
export * from "./WeeklyThermalCpuBurnInFailRateSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports